import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { FieldsOptionsService } from '../../../services/fields-options.service';

@Injectable()
export class VacantPositionFieldsResolver implements Resolve<any> {

  constructor(private fieldsOptionsService: FieldsOptionsService) { }

  public resolve() {
    return this.fieldsOptionsService.getVacantPositionFields();
  }
}
